module.exports = __webpack_public_path__ + "c1326d358c4dca2730780bba1024e5a8.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/40k_logo.png
// module id = 143
// module chunks = 0